import React from "react";
import Chart from "react-apexcharts";
import { Card } from "reactstrap";

const OrderStatusChart = () => {
  // Mock Data: Replace with API response later
  const series = [450, 120, 30]; // Completed, Pending, Cancelled
  const labels = ["Completed", "Pending", "Cancelled"];
  
  const totalOrders = series.reduce((a, b) => a + b, 0);

  const chartOptions = {
    chart: {
      type: "donut",
      fontFamily: 'inherit',
    },
    labels: labels,
    colors: ["#10b981", "#f59e0b", "#ef4444"],
    plotOptions: {
      pie: {
        donut: {
          size: '75%',
          labels: {
            show: true,
            name: {
              fontSize: '14px',
              color: '#6b7280',
              fontWeight: 500
            },
            value: {
              fontSize: '24px',
              color: '#111827',
              fontWeight: 700,
              formatter: (val) => val
            },
            total: {
              show: true,
              label: 'Total Orders',
              color: '#6b7280',
              formatter: () => totalOrders
            }
          }
        }
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: 0
    },
    legend: {
      position: 'bottom',
      markers: { radius: 12 },
      itemMargin: { horizontal: 10, vertical: 5 }
    },
    tooltip: {
      theme: 'light',
      y: {
        formatter: (val) => `${val} Orders`
      }
    }
  };

  return (
    <Card className="chart-card border-0 shadow-sm rounded-4 h-100 p-4">
      <div className="mb-4 text-center">
        <h3 className="fs-18 fw-bold text-dark mb-1">Order Status</h3>
        <p className="fs-13 text-muted mb-0">Current status of all orders</p>
      </div>
      
      <div className="d-flex justify-content-center align-items-center h-100" style={{ minHeight: '320px' }}>
        <Chart
          options={chartOptions}
          series={series}
          type="donut"
          height={320}
          width="100%"
        />
      </div>
    </Card>
  );
};

export default OrderStatusChart;
